import analytics from "../analytics/index.mjs";
import { trackedJsonRequest } from "../trackedRequest.mjs";
async function getAppleSearchAdsAttribution(module) {
  try {
    const result = await module.fetch();
    if (!result.attribution) {
      return void 0;
    }
    const { orgId, campaignId, adGroupId, adId, keywordId } = result;
    const response = await trackedJsonRequest(
      fetch,
      "https://asa-attr.dev.gc-internal.net/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: {
          orgId,
          campaignId,
          adGroupId,
          adId,
          keywordId
        },
        tracking: {
          platform: "Core",
          source: "getAppleSearchAdsAttribution"
        }
      }
    );
    const json = await response.json();
    return {
      $channel: "AD",
      $adNetworkName: "Apple Search Ads",
      $adCampaignName: json.campaignName,
      $adSetName: json.adGroupName,
      $adCreativeName: json.adName
    };
  } catch {
    return void 0;
  }
}
async function getAppsFlyerAttribution(module) {
  try {
    const result = await module.getConversionData();
    if (result.type === "failure") {
      analytics.pushError("GetAppsFlyerAttributionFailure", {
        errorMessage: result.error
      });
      return void 0;
    }
    if (typeof result.data !== "object") {
      return void 0;
    }
    const data = result.data;
    if (typeof data.af_status !== "string" || data.af_status !== "Non-organic") {
      return void 0;
    }
    const payload = {
      $channel: "AD"
    };
    if (typeof data.campaign === "string") {
      payload.$adCampaignName = data.campaign;
    }
    if (typeof data.media_source === "string") {
      const mediaSources = {
        bytedanceglobal_int: "App_TikTok",
        lap_int: "App_LINE",
        Twitter: "App_Twitter",
        "Facebook Ads": "App_Facebook",
        googleadwords_int: "App_Google"
      };
      payload.$adNetworkName = mediaSources[data.media_source];
    }
    if (typeof data.af_ad === "string") {
      payload.$adCreativeName = data.af_ad;
    }
    if (typeof data.af_adset === "string") {
      payload.$adSetName = data.af_adset;
    }
    return payload;
  } catch {
    return void 0;
  }
}
export {
  getAppleSearchAdsAttribution,
  getAppsFlyerAttribution
};
